
import React from 'react';
// Styles
import StyleWrapper from './Wrapper';

export default class HeaderWrapper extends React.Component {
    render() {
        return (
            <StyleWrapper className="header-wrapper" theme={this.props.theme ? this.props.theme : ""}>
                {this.props.children}
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/components/Headers/index.js